import { APP_NAME, $document } from '../utils/environment';
import { module } from 'modujs';
import VueCardFormat from 'vue-credit-card-validation';
import { VueRecaptcha } from 'vue-recaptcha';

const MODULE_NAME = 'Giftcardpay';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

export default class extends module {
    constructor(m) {
        super(m);

    }

    init() {

        Vue.use(VueCardFormat);
        
        let paymentVue = new Vue({
            el: this.el,
            data: {
                total: parseFloat(this.el.dataset.total),
                items: [],
                tid: this.el.dataset.id,
                token: this.el.dataset.token,
                type: '',
                number: '',
                balance: 0,
                loading: false,
                carderror: false,
                state: 'validate',
                method: '',
                ccnumber: '',
                ccname: '',
                ccexp: '',
                cccvd: '',
                cnum: '',
                cexp: '',
                csec: '',
                error:'',
                paypalcid: this.el.dataset.paypalid,
                cardBrand: null,
                cfnumber: '',
            },
            filters: {
                money(nb) {
                    return nb.toFixed(2)+'$';
                }
            },
            components: {
                'vue-recaptcha': VueRecaptcha,
              },
            methods: {
                changeNumber(e){
                    if(this.type == 'points'){
                        this.number = this.cfnumber;
                    } else {
                        this.number = '';
                    }
                },
                fetchProducts() {
                    this.items = Snipcart.store.getState().cart.items.items;
                },
                complete(recaptchaToken) {
                    if (this.loading) return;
                    this.loading=true;
                    this.carderror = false;
                    let fd = new FormData();
                    fd.append('type',this.type);
                    fd.append('number',this.number);
                    fd.append('tid',this.tid);
                    fd.append('token',this.token);
                    fd.append('items',JSON.stringify(Snipcart.store.getState().cart.items.items));
                    fd.append('total',this.total);
                    let url = this.type=='giftcard' ? 'giftcardpayment' : 'fidelitypayment'
                    fetch('/wp-json/freebees/v1/'+url,{method: "POST",body: fd})
                    .then(response => response.json())
                    .then(data => {

                        if (data.success) {
                            location.href=data.url;
                        }
                        else {
                            this.carderror = true;
                            this.error = data.error;
                        }
                        this.loading=false
                    });
                },
                completeWithCard(recaptchaToken) {
                    if (this.loading) return;
                    this.loading=true;
                    this.carderror = false;
                    let amount = this.total-this.balance;
                    amount = Math.round(amount*100)/100
                    let fd = new FormData();
                    fd.append('address', Snipcart.store.getState().cart.billingAddress.fullAddress)
                    fd.append('postal_code', Snipcart.store.getState().cart.billingAddress.postalCode);
                    fd.append('cnum',this.cnum);
                    fd.append('cbrand',this.cardBrand);
                    fd.append('cexp',this.cexp);
                    fd.append('csec',this.csec);
                    fd.append('type',this.type);
                    fd.append('number',this.number);
                    fd.append('tid',this.tid);
                    fd.append('token',this.token);
                    fd.append('items',JSON.stringify(this.items));
                    fd.append('total',this.total);
                    fd.append('freebeesamount',this.balance);
                    fd.append('payfactoamount',amount);
                    let url = this.type=='giftcard' ? 'giftcardpaymentwithcard' : 'fidelitypaymentwithcard'
                    if(this.balance == 0) url = 'paymentpayfacto'
                    fetch('/wp-json/freebees/v1/'+url,{method: "POST",body: fd})
                    .then(response => response.json())
                    .then(data => {

                        if (data.success) {
                            location.href=data.url;
                        }
                        else {
                            this.carderror = true;
                            this.cnum = '';
                            this.cexp = '';
                            this.csec = '';
                            this.error = data.error;
                        }
                        this.loading=false
                    });
                },
                completeOnlyCard(recaptchaToken) {
                    if (this.loading) return;
                    this.loading=true;
                    this.carderror = false;
                    let amount = this.total-this.balance;
                    amount = Math.round(amount*100)/100
                    let fd = new FormData();
                    fd.append('address', Snipcart.store.getState().cart.billingAddress.fullAddress)
                    fd.append('postal_code', Snipcart.store.getState().cart.billingAddress.postalCode);
                    fd.append('cnum',this.cnum);
                    fd.append('cbrand',this.cardBrand);
                    fd.append('cexp',this.cexp);
                    fd.append('csec',this.csec);
                    fd.append('tid',this.tid);
                    fd.append('token',this.token);
                    fd.append('items',JSON.stringify(Snipcart.store.getState().cart.items.items));
                    fd.append('total',this.total);
                    let url = 'paymentpayfacto'
                    fetch('/wp-json/freebees/v1/'+url,{method: "POST",body: fd})
                    .then(response => response.json())
                    .then(data => {

                        if (data.success) {
                            location.href=data.url;
                        }
                        else {
                            this.carderror = true;
                            this.cnum = '';
                            this.cexp = '';
                            this.csec = '';
                            this.error = data.error;
                        }
                        this.loading=false
                    });
                },
                recaptchaValidate(){
                    this.$refs.recaptcha.execute();
                },
                onCaptchaExpired: function (recaptchaToken) {
                    this.$refs.recaptcha.reset();
                },
                validateCard() {
                    if (this.loading) return;
                    this.loading=true;
                    this.carderror = false;
                    this.error = '';
                    let fd = new FormData();
                    fd.append('items',JSON.stringify(this.items));
                    fd.append('type',this.type);
                    fd.append('number',this.number);
                    fetch('/wp-json/freebees/v1/validate',{method: "POST",body: fd})
                    .then(response => response.json())
                    .then(data => {

                        if (data.success) {
                            this.balance = data.balance;
                            if(data.balance == 0) console.log('toto');
                            this.number = data.number;
                            if (this.balance >= this.total) {
                                this.state = 'complete'
                            }
                            else {
                                this.state = 'cc'
                            }
                        }
                        else {
                            this.carderror = true;
                            this.error = data.error;
                        }
                        this.loading=false
                    });
                },
            },
            mounted() {
                Snipcart.events.on('snipcart.initialized', (snipcartState) => {
                    this.cfnumber = snipcartState.cart.billingAddress.company;
                });
                this.fetchProducts();
            }
        })

    }

    // Destroy
    // ==========================================================================
    destroy() {
        super.destroy()
    }
}

